
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  computed,
  provide,
  ref,
  useContext,
  useRoute,
  useRouter,
  useAsync,
  watch
} from '@nuxtjs/composition-api'
import useErrorHandler from '~/composable/useErrorHandler';
export default {
  name: 'TlmHeader',
  components: { FontAwesomeIcon },
  props: {
    btnColor: {
      default: 'white',
      type: String
    }
  },
  setup() {
    const root = ref(null);
    const showMobileMenu = ref(false);
    const showMobileMenuTop = ref(false);
    const showHeaderItem = ref('');
    const context = useContext();
    const route = useRoute();
    const router = useRouter();
    const { catchApiFailureWithNoAction } = useErrorHandler()

    const menuData = computed(() => headerData?.value?.menu);
    const infoBanners = computed(() => headerData?.value?.infoBanners)

    const toggleMobileMenu = (bool) => {
      showMobileMenuTop.value = bool;
      if (bool) {
        showMobileMenu.value = bool
      } else {
        setTimeout(() => {
          showMobileMenu.value = bool;
        }, 150);
      }
      // activate the submenu again if it has been hidden
      root.value?.querySelectorAll('.is-active-mobile').forEach(element => element.classList.remove('is-active-mobile'))
      root.value?.querySelectorAll('.tlm-header__menu-sub.mobile-menu-active').forEach((element) => {
        element.classList.add('is-active-mobile');
      });
    };

    watch(route, () => toggleMobileMenu(false));

    // data for header
    const headerData = useAsync(() => {
      return context.$hubble.pageResources.getHeader().then(res => {
        return res.data
      }).catch(e => catchApiFailureWithNoAction(e))
    },
    'headerData')


    // provide data to header item components
    provide('headerData', headerData)

    // data for header item buttons
    const headerItems = [
      {
        name: 'search',
        label: 'Søg',
        icon: 'search',
        component: 'lazy-tlm-header-item-search'
      },
      {
        name: 'contact',
        label: 'Kontakt',
        icon: 'phone',
        component: 'lazy-tlm-header-item-contact'
      }
    ];

    // toggles the header item drawers (search, contact, my telmore)
    const toggleHeaderItem = (item) => {
      if (showHeaderItem.value === item) {
        showHeaderItem.value = '';
        return;
      }
      showHeaderItem.value = item;
    };

    const hideSubMenu = (e) => {
      e.target?.closest('.tlm-header__menu-sub').classList.remove('is-active-mobile');
    };

    const showSubMenu = (e) => {
      const menu = e.target?.closest('.tlm-header__nav-item')
      const sub = menu.querySelector('.tlm-header__menu-sub')
      sub.classList.add('is-active-mobile')
    }
    const mainMenuItemsNotRoot = computed(() => menuData.value.filter(item => !(item.url === router.options.base || (item.url + '/') === router.options.base)))
    // eslint-disable-next-line complexity
    const isRouteActive = (item) => {
      const isNotOtherThenRoot = mainMenuItemsNotRoot.value.find(it => it.url === item.url)
      const isRoot = item.url === router.options.base || (item.url + '/') === router.options.base
      const matchesItem = route.value.path.includes(router.match(item.url.replace(router.options.base, '/')).path)
      const matchesSubItem = item.items?.find((subItem) => route.value.path.includes(router.match(subItem.url.replace(router.options.base, '/')).path));
      return route.value.path !== '/shopkoeb' && (matchesItem || matchesSubItem || (isRoot && isNotOtherThenRoot))
    };
    return {
      infoBanners,
      root,
      showSubMenu,
      isRouteActive,
      headerItems,
      headerData,
      menuData,
      hideSubMenu,
      toggleMobileMenu,
      showMobileMenu,
      showMobileMenuTop,
      toggleHeaderItem,
      showHeaderItem
    };
  }
}
